import {
  SEED_APPROVED_STAFF_LEAVE,
  SEED_APPROVED_STAFF_LEAVE_SUCCESS,
  SEED_APPROVED_STAFF_LEAVE_FAIL,
  STAFF_HOLIDAY_CALENDAR_LIST,
  STAFF_HOLIDAY_CALENDAR_LIST_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_LIST_FAIL,
  STAFF_HOLIDAY_CALENDAR_DATA,
  STAFF_HOLIDAY_CALENDAR_DATA_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_DATA_FAIL,
  STAFF_HOLIDAY_CALENDAR_CREATE,
  STAFF_HOLIDAY_CALENDAR_CREATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_CREATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_UPDATE,
  STAFF_HOLIDAY_CALENDAR_UPDATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_UPDATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_DELETE,
  STAFF_HOLIDAY_CALENDAR_DELETE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_DELETE_FAIL,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_FAIL,
  CALENDAR_NON_WORKING_DAY_LIST,
  CALENDAR_NON_WORKING_DAY_LIST_SUCCESS,
  CALENDAR_NON_WORKING_DAY_LIST_FAIL,
  CALENDAR_NON_WORKING_DAY_DATA,
  CALENDAR_NON_WORKING_DAY_DATA_SUCCESS,
  CALENDAR_NON_WORKING_DAY_DATA_FAIL,
  CALENDAR_NON_WORKING_DAY_CREATE,
  CALENDAR_NON_WORKING_DAY_CREATE_SUCCESS,
  CALENDAR_NON_WORKING_DAY_CREATE_FAIL,
  CALENDAR_NON_WORKING_DAY_UPDATE,
  CALENDAR_NON_WORKING_DAY_UPDATE_SUCCESS,
  CALENDAR_NON_WORKING_DAY_UPDATE_FAIL,
  CALENDAR_NON_WORKING_DAY_DELETE,
  CALENDAR_NON_WORKING_DAY_DELETE_SUCCESS,
  CALENDAR_NON_WORKING_DAY_DELETE_FAIL,
  STAFF_LEAVE_CREATE_REQUEST,
  STAFF_LEAVE_CREATE_REQUEST_SUCCESS,
  STAFF_LEAVE_CREATE_REQUEST_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
  STAFF_LEAVE_DECISION_APPROVE,
  STAFF_LEAVE_DECISION_APPROVE_SUCCESS,
  STAFF_LEAVE_DECISION_APPROVE_FAIL,
  STAFF_LEAVE_DECISION_DECLINE,
  STAFF_LEAVE_DECISION_DECLINE_SUCCESS,
  STAFF_LEAVE_DECISION_DECLINE_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_FAIL,
  STAFF_LEAVE_DECISION_DATA,
  STAFF_LEAVE_DECISION_DATA_SUCCESS,
  STAFF_LEAVE_DECISION_DATA_FAIL,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN_SUCCESS,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN_FAIL,
  STAFF_LEAVE_DECISION_LIST,
  STAFF_LEAVE_DECISION_LIST_SUCCESS,
  STAFF_LEAVE_DECISION_LIST_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_FAIL,
} from "./actionType";

const initialData = {
  staffHolidayCalendarList: [],
  staffHolidayCalendarListLoading: false,
  staffHolidayCalendarListError: null,

  staffHolidayCalendarData: [],
  staffHolidayCalendarDataLoading: false,
  staffHolidayCalendarDataError: null,

  staffHolidayCalendarCreate: [],
  staffHolidayCalendarCreateLoading: false,
  staffHolidayCalendarCreateError: null,

  staffHolidayCalendarUpdate: [],
  staffHolidayCalendarUpdateLoading: false,
  staffHolidayCalendarUpdateError: null,

  staffHolidayCalendarDelete: [],
  staffHolidayCalendarDeleteLoading: false,
  staffHolidayCalendarDeleteError: null,

  staffHolidayCalendarGeneratePeriods: [],
  staffHolidayCalendarGeneratePeriodsLoading: false,
  staffHolidayCalendarGeneratePeriodsError: null,

  staffHolidayCalendarPeriodList: [],
  staffHolidayCalendarPeriodListLoading: false,
  staffHolidayCalendarPeriodListError: null,

  staffHolidayCalendarPeriodData: [],
  staffHolidayCalendarPeriodDataLoading: false,
  staffHolidayCalendarPeriodDataError: null,

  staffHolidayCalendarPeriodCreate: [],
  staffHolidayCalendarPeriodCreateLoading: false,
  staffHolidayCalendarPeriodCreateError: null,

  staffHolidayCalendarPeriodUpdate: [],
  staffHolidayCalendarPeriodUpdateLoading: false,
  staffHolidayCalendarPeriodUpdateError: null,

  staffHolidayCalendarPeriodDelete: [],
  staffHolidayCalendarPeriodDeleteLoading: false,
  staffHolidayCalendarPeriodDeleteError: null,

  calendarNonWorkingDayList: [],
  calendarNonWorkingDayListLoading: false,
  calendarNonWorkingDayListError: null,

  calendarNonWorkingDayData: [],
  calendarNonWorkingDayDataLoading: false,
  calendarNonWorkingDayDataError: null,

  calendarNonWorkingDayCreate: [],
  calendarNonWorkingDayCreateLoading: false,
  calendarNonWorkingDayCreateError: null,

  calendarNonWorkingDayUpdate: [],
  calendarNonWorkingDayUpdateLoading: false,
  calendarNonWorkingDayUpdateError: null,

  calendarNonWorkingDayDelete: [],
  calendarNonWorkingDayDeleteLoading: false,
  calendarNonWorkingDayDeleteError: null,

  staffLeaveCreateRequest: [],
  staffLeaveCreateRequestLoading: false,
  staffLeaveCreateRequestError: null,

  staffToStaffHolidayCalendarPeriodListCurrent: [],
  staffToStaffHolidayCalendarPeriodListCurrentLoading: false,
  staffToStaffHolidayCalendarPeriodListCurrentError: null,

  staffToStaffHolidayCalendarPeriodListFuture: [],
  staffToStaffHolidayCalendarPeriodListFutureLoading: false,
  staffToStaffHolidayCalendarPeriodListFutureError: null,

  staffToStaffHolidayCalendarPeriodListPast: [],
  staffToStaffHolidayCalendarPeriodListPastLoading: false,
  staffToStaffHolidayCalendarPeriodListPastError: null,

  staffToStaffHolidayCalendarPeriodList: [],
  staffToStaffHolidayCalendarPeriodListLoading: false,
  staffToStaffHolidayCalendarPeriodListError: null,

  staffLeaveDecisionApprove: [],
  staffLeaveDecisionApproveLoading: false,
  staffLeaveDecisionApproveError: null,

  staffLeaveDecisionDecline: [],
  staffLeaveDecisionDeclineLoading: false,
  staffLeaveDecisionDeclineError: null,

  staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers: [],
  staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersLoading: false,
  staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersError: null,

  staffToStaffHolidayCalendarPeriodListCurrentMy: [],
  staffToStaffHolidayCalendarPeriodListCurrentMyLoading: false,
  staffToStaffHolidayCalendarPeriodListCurrentMyError: null,

  staffLeaveDecisionData: [],
  staffLeaveDecisionDataLoading: false,
  staffLeaveDecisionDataError: null,

  staffLeaveDecisionListMyOpen: [],
  staffLeaveDecisionListMyOpenLoading: false,
  staffLeaveDecisionListMyOpenError: null,

  staffLeaveDecisionList: [],
  staffLeaveDecisionListLoading: false,
  staffLeaveDecisionListError: null,

  overviewStaffToStaffHolidayCalendarPeriodListCurrent: [],
  overviewStaffToStaffHolidayCalendarPeriodListCurrentLoading: false,
  overviewStaffToStaffHolidayCalendarPeriodListCurrentError: null,

  overviewStaffToStaffHolidayCalendarPeriodListFuture: [],
  overviewStaffToStaffHolidayCalendarPeriodListFutureLoading: false,
  overviewStaffToStaffHolidayCalendarPeriodListFutureError: null,

  overviewStaffToStaffHolidayCalendarPeriodListPast: [],
  overviewStaffToStaffHolidayCalendarPeriodListPastLoading: false,
  overviewStaffToStaffHolidayCalendarPeriodListPastError: null,

  overviewStaffToStaffHolidayCalendarPeriodList: [],
  overviewStaffToStaffHolidayCalendarPeriodListLoading: false,
  overviewStaffToStaffHolidayCalendarPeriodListError: null,

  staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers: [],
  staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersLoading: false,
  staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersError: null,

  staffToStaffHolidayCalendarPeriodSearch: [],
  staffToStaffHolidayCalendarPeriodSearchLoading: false,
  staffToStaffHolidayCalendarPeriodSearchError: null,

  staffLeaveRestrictionPeriodList: [],
  staffLeaveRestrictionPeriodListLoading: false,
  staffLeaveRestrictionPeriodListError: null,

  staffLeaveRestrictionPeriodData: [],
  staffLeaveRestrictionPeriodDataLoading: false,
  staffLeaveRestrictionPeriodDataError: null,

  staffLeaveRestrictionPeriodCreate: [],
  staffLeaveRestrictionPeriodCreateLoading: false,
  staffLeaveRestrictionPeriodCreateError: null,

  staffLeaveRestrictionPeriodUpdate: [],
  staffLeaveRestrictionPeriodUpdateLoading: false,
  staffLeaveRestrictionPeriodUpdateError: null,

  staffLeaveRestrictionPeriodDelete: [],
  staffLeaveRestrictionPeriodDeleteLoading: false,
  staffLeaveRestrictionPeriodDeleteError: null,
};

const StaffLeave = (state = initialData, action) => {
  switch (action.type) {
    case STAFF_HOLIDAY_CALENDAR_LIST:
      return {
        ...state,
        staffHolidayCalendarListLoading: true,
        staffHolidayCalendarListError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_LIST_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarList: action.payload,
        staffHolidayCalendarListLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_LIST_FAIL:
      return {
        ...state,
        staffHolidayCalendarList: [],
        staffHolidayCalendarListLoading: false,
        staffHolidayCalendarListError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_DATA:
      return {
        ...state,
        staffHolidayCalendarDataLoading: true,
        staffHolidayCalendarDataError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_DATA_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarData: action.payload,
        staffHolidayCalendarDataLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_DATA_FAIL:
      return {
        ...state,
        staffHolidayCalendarData: [],
        staffHolidayCalendarDataLoading: false,
        staffHolidayCalendarDataError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_CREATE:
      return {
        ...state,
        staffHolidayCalendarCreateLoading: true,
        staffHolidayCalendarCreateError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_CREATE_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarCreate: action.payload,
        staffHolidayCalendarCreateLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_CREATE_FAIL:
      return {
        ...state,
        staffHolidayCalendarCreate: [],
        staffHolidayCalendarCreateLoading: false,
        staffHolidayCalendarCreateError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_UPDATE:
      return {
        ...state,
        staffHolidayCalendarUpdateLoading: true,
        staffHolidayCalendarUpdateError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_UPDATE_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarUpdate: action.payload,
        staffHolidayCalendarUpdateLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_UPDATE_FAIL:
      return {
        ...state,
        staffHolidayCalendarUpdate: [],
        staffHolidayCalendarUpdateLoading: false,
        staffHolidayCalendarUpdateError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_DELETE:
      return {
        ...state,
        staffHolidayCalendarDeleteLoading: true,
        staffHolidayCalendarDeleteError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_DELETE_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarDelete: action.payload,
        staffHolidayCalendarDeleteLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_DELETE_FAIL:
      return {
        ...state,
        staffHolidayCalendarDelete: [],
        staffHolidayCalendarDeleteLoading: false,
        staffHolidayCalendarDeleteError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS:
      return {
        ...state,
        staffHolidayCalendarGeneratePeriodsLoading: true,
        staffHolidayCalendarGeneratePeriodsError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarGeneratePeriods: action.payload,
        staffHolidayCalendarGeneratePeriodsLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_FAIL:
      return {
        ...state,
        staffHolidayCalendarGeneratePeriods: [],
        staffHolidayCalendarGeneratePeriodsLoading: false,
        staffHolidayCalendarGeneratePeriodsError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_PERIOD_LIST:
      return {
        ...state,
        staffHolidayCalendarPeriodListLoading: true,
        staffHolidayCalendarPeriodListError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarPeriodList: action.payload,
        staffHolidayCalendarPeriodListLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL:
      return {
        ...state,
        staffHolidayCalendarPeriodList: [],
        staffHolidayCalendarPeriodListLoading: false,
        staffHolidayCalendarPeriodListError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_PERIOD_DATA:
      return {
        ...state,
        staffHolidayCalendarPeriodDataLoading: true,
        staffHolidayCalendarPeriodDataError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarPeriodData: action.payload,
        staffHolidayCalendarPeriodDataLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_FAIL:
      return {
        ...state,
        staffHolidayCalendarPeriodData: [],
        staffHolidayCalendarPeriodDataLoading: false,
        staffHolidayCalendarPeriodDataError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE:
      return {
        ...state,
        staffHolidayCalendarPeriodCreateLoading: true,
        staffHolidayCalendarPeriodCreateError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarPeriodCreate: action.payload,
        staffHolidayCalendarPeriodCreateLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_FAIL:
      return {
        ...state,
        staffHolidayCalendarPeriodCreate: [],
        staffHolidayCalendarPeriodCreateLoading: false,
        staffHolidayCalendarPeriodCreateError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE:
      return {
        ...state,
        staffHolidayCalendarPeriodUpdateLoading: true,
        staffHolidayCalendarPeriodUpdateError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarPeriodUpdate: action.payload,
        staffHolidayCalendarPeriodUpdateLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_FAIL:
      return {
        ...state,
        staffHolidayCalendarPeriodUpdate: [],
        staffHolidayCalendarPeriodUpdateLoading: false,
        staffHolidayCalendarPeriodUpdateError: action.payload,
      };

    case STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE:
      return {
        ...state,
        staffHolidayCalendarPeriodDeleteLoading: true,
        staffHolidayCalendarPeriodDeleteError: null,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_SUCCESS:
      return {
        ...state,
        staffHolidayCalendarPeriodDelete: action.payload,
        staffHolidayCalendarPeriodDeleteLoading: false,
      };
    case STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_FAIL:
      return {
        ...state,
        staffHolidayCalendarPeriodDelete: [],
        staffHolidayCalendarPeriodDeleteLoading: false,
        staffHolidayCalendarPeriodDeleteError: action.payload,
      };

    case CALENDAR_NON_WORKING_DAY_LIST:
      return {
        ...state,
        calendarNonWorkingDayListLoading: true,
        calendarNonWorkingDayListError: null,
      };
    case CALENDAR_NON_WORKING_DAY_LIST_SUCCESS:
      return {
        ...state,
        calendarNonWorkingDayList: action.payload,
        calendarNonWorkingDayListLoading: false,
      };
    case CALENDAR_NON_WORKING_DAY_LIST_FAIL:
      return {
        ...state,
        calendarNonWorkingDayList: [],
        calendarNonWorkingDayListLoading: false,
        calendarNonWorkingDayListError: action.payload,
      };

    case CALENDAR_NON_WORKING_DAY_DATA:
      return {
        ...state,
        calendarNonWorkingDayDataLoading: true,
        calendarNonWorkingDayDataError: null,
      };
    case CALENDAR_NON_WORKING_DAY_DATA_SUCCESS:
      return {
        ...state,
        calendarNonWorkingDayData: action.payload,
        calendarNonWorkingDayDataLoading: false,
      };
    case CALENDAR_NON_WORKING_DAY_DATA_FAIL:
      return {
        ...state,
        calendarNonWorkingDayData: [],
        calendarNonWorkingDayDataLoading: false,
        calendarNonWorkingDayDataError: action.payload,
      };

    case CALENDAR_NON_WORKING_DAY_CREATE:
      return {
        ...state,
        calendarNonWorkingDayCreateLoading: true,
        calendarNonWorkingDayCreateError: null,
      };
    case CALENDAR_NON_WORKING_DAY_CREATE_SUCCESS:
      return {
        ...state,
        calendarNonWorkingDayCreate: action.payload,
        calendarNonWorkingDayCreateLoading: false,
      };
    case CALENDAR_NON_WORKING_DAY_CREATE_FAIL:
      return {
        ...state,
        calendarNonWorkingDayCreate: [],
        calendarNonWorkingDayCreateLoading: false,
        calendarNonWorkingDayCreateError: action.payload,
      };

    case CALENDAR_NON_WORKING_DAY_UPDATE:
      return {
        ...state,
        calendarNonWorkingDayUpdateLoading: true,
        calendarNonWorkingDayUpdateError: null,
      };
    case CALENDAR_NON_WORKING_DAY_UPDATE_SUCCESS:
      return {
        ...state,
        calendarNonWorkingDayUpdate: action.payload,
        calendarNonWorkingDayUpdateLoading: false,
      };
    case CALENDAR_NON_WORKING_DAY_UPDATE_FAIL:
      return {
        ...state,
        calendarNonWorkingDayUpdate: [],
        calendarNonWorkingDayUpdateLoading: false,
        calendarNonWorkingDayUpdateError: action.payload,
      };

    case CALENDAR_NON_WORKING_DAY_DELETE:
      return {
        ...state,
        calendarNonWorkingDayDeleteLoading: true,
        calendarNonWorkingDayDeleteError: null,
      };
    case CALENDAR_NON_WORKING_DAY_DELETE_SUCCESS:
      return {
        ...state,
        calendarNonWorkingDayDelete: action.payload,
        calendarNonWorkingDayDeleteLoading: false,
      };
    case CALENDAR_NON_WORKING_DAY_DELETE_FAIL:
      return {
        ...state,
        calendarNonWorkingDayDelete: [],
        calendarNonWorkingDayDeleteLoading: false,
        calendarNonWorkingDayDeleteError: action.payload,
      };
    case STAFF_LEAVE_CREATE_REQUEST:
      return {
        ...state,
        staffLeaveCreateRequestLoading: true,
        staffLeaveCreateRequestError: null,
      };
    case STAFF_LEAVE_CREATE_REQUEST_SUCCESS:
      return {
        ...state,
        staffLeaveCreateRequest: action.payload,
        staffLeaveCreateRequestLoading: false,
      };
    case STAFF_LEAVE_CREATE_REQUEST_FAIL:
      return {
        ...state,
        staffLeaveCreateRequest: [],
        staffLeaveCreateRequestLoading: false,
        staffLeaveCreateRequestError: action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentLoading: true,
        staffToStaffHolidayCalendarPeriodListCurrentError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrent: action.payload,
        staffToStaffHolidayCalendarPeriodListCurrentLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrent: [],
        staffToStaffHolidayCalendarPeriodListCurrentLoading: false,
        staffToStaffHolidayCalendarPeriodListCurrentError: action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListFutureLoading: true,
        staffToStaffHolidayCalendarPeriodListFutureError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListFuture: action.payload,
        staffToStaffHolidayCalendarPeriodListFutureLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListFuture: [],
        staffToStaffHolidayCalendarPeriodListFutureLoading: false,
        staffToStaffHolidayCalendarPeriodListFutureError: action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListPastLoading: true,
        staffToStaffHolidayCalendarPeriodListPastError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListPast: action.payload,
        staffToStaffHolidayCalendarPeriodListPastLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListPast: [],
        staffToStaffHolidayCalendarPeriodListPastLoading: false,
        staffToStaffHolidayCalendarPeriodListPastError: action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListLoading: true,
        staffToStaffHolidayCalendarPeriodListError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodList: action.payload,
        staffToStaffHolidayCalendarPeriodListLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodList: [],
        staffToStaffHolidayCalendarPeriodListLoading: false,
        staffToStaffHolidayCalendarPeriodListError: action.payload,
      };
    case STAFF_LEAVE_DECISION_APPROVE:
      return {
        ...state,
        staffLeaveDecisionApproveLoading: true,
        staffLeaveDecisionApproveError: null,
      };
    case STAFF_LEAVE_DECISION_APPROVE_SUCCESS:
      return {
        ...state,
        staffLeaveDecisionApprove: action.payload,
        staffLeaveDecisionApproveLoading: false,
      };
    case STAFF_LEAVE_DECISION_APPROVE_FAIL:
      return {
        ...state,
        staffLeaveDecisionApprove: [],
        staffLeaveDecisionApproveLoading: false,
        staffLeaveDecisionApproveError: action.payload,
      };
    case STAFF_LEAVE_DECISION_DECLINE:
      return {
        ...state,
        staffLeaveDecisionDeclineLoading: true,
        staffLeaveDecisionDeclineError: null,
      };
    case STAFF_LEAVE_DECISION_DECLINE_SUCCESS:
      return {
        ...state,
        staffLeaveDecisionDecline: action.payload,
        staffLeaveDecisionDeclineLoading: false,
      };
    case STAFF_LEAVE_DECISION_DECLINE_FAIL:
      return {
        ...state,
        staffLeaveDecisionDecline: [],
        staffLeaveDecisionDeclineLoading: false,
        staffLeaveDecisionDeclineError: action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersLoading: true,
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers:
          action.payload,
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers: [],
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersLoading: false,
        staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersError:
          action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentMyLoading: true,
        staffToStaffHolidayCalendarPeriodListCurrentMyError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentMy: action.payload,
        staffToStaffHolidayCalendarPeriodListCurrentMyLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListCurrentMy: [],
        staffToStaffHolidayCalendarPeriodListCurrentMyLoading: false,
        staffToStaffHolidayCalendarPeriodListCurrentMyError: action.payload,
      };
    case STAFF_LEAVE_DECISION_DATA:
      return {
        ...state,
        staffLeaveDecisionDataLoading: true,
        staffLeaveDecisionDataError: null,
      };
    case STAFF_LEAVE_DECISION_DATA_SUCCESS:
      return {
        ...state,
        staffLeaveDecisionData: action.payload,
        staffLeaveDecisionDataLoading: false,
      };
    case STAFF_LEAVE_DECISION_DATA_FAIL:
      return {
        ...state,
        staffLeaveDecisionData: [],
        staffLeaveDecisionDataLoading: false,
        staffLeaveDecisionDataError: action.payload,
      };
    case STAFF_LEAVE_DECISION_LIST_MY_OPEN:
      return {
        ...state,
        staffLeaveDecisionListMyOpenLoading: true,
        staffLeaveDecisionListMyOpenError: null,
      };
    case STAFF_LEAVE_DECISION_LIST_MY_OPEN_SUCCESS:
      return {
        ...state,
        staffLeaveDecisionListMyOpen: action.payload,
        staffLeaveDecisionListMyOpenLoading: false,
      };
    case STAFF_LEAVE_DECISION_LIST_MY_OPEN_FAIL:
      return {
        ...state,
        staffLeaveDecisionListMyOpen: [],
        staffLeaveDecisionListMyOpenLoading: false,
        staffLeaveDecisionListMyOpenError: action.payload,
      };
    case STAFF_LEAVE_DECISION_LIST:
      return {
        ...state,
        staffLeaveDecisionListLoading: true,
        staffLeaveDecisionListError: null,
      };
    case STAFF_LEAVE_DECISION_LIST_SUCCESS:
      return {
        ...state,
        staffLeaveDecisionList: action.payload,
        staffLeaveDecisionListLoading: false,
      };
    case STAFF_LEAVE_DECISION_LIST_FAIL:
      return {
        ...state,
        staffLeaveDecisionList: [],
        staffLeaveDecisionListLoading: false,
        staffLeaveDecisionListError: action.payload,
      };

    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListCurrentLoading: true,
        overviewStaffToStaffHolidayCalendarPeriodListCurrentError: null,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListCurrent: action.payload,
        overviewStaffToStaffHolidayCalendarPeriodListCurrentLoading: false,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListCurrent: [],
        overviewStaffToStaffHolidayCalendarPeriodListCurrentLoading: false,
        overviewStaffToStaffHolidayCalendarPeriodListCurrentError:
          action.payload,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListFutureLoading: true,
        overviewStaffToStaffHolidayCalendarPeriodListFutureError: null,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListFuture: action.payload,
        overviewStaffToStaffHolidayCalendarPeriodListFutureLoading: false,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListFuture: [],
        overviewStaffToStaffHolidayCalendarPeriodListFutureLoading: false,
        overviewStaffToStaffHolidayCalendarPeriodListFutureError:
          action.payload,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListPastLoading: true,
        overviewStaffToStaffHolidayCalendarPeriodListPastError: null,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListPast: action.payload,
        overviewStaffToStaffHolidayCalendarPeriodListPastLoading: false,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListPast: [],
        overviewStaffToStaffHolidayCalendarPeriodListPastLoading: false,
        overviewStaffToStaffHolidayCalendarPeriodListPastError: action.payload,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodListLoading: true,
        overviewStaffToStaffHolidayCalendarPeriodListError: null,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodList: action.payload,
        overviewStaffToStaffHolidayCalendarPeriodListLoading: false,
      };
    case OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL:
      return {
        ...state,
        overviewStaffToStaffHolidayCalendarPeriodList: [],
        overviewStaffToStaffHolidayCalendarPeriodListLoading: false,
        overviewStaffToStaffHolidayCalendarPeriodListError: action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersLoading: true,
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers:
          action.payload,
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers: [],
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersLoading: false,
        staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersError:
          action.payload,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodSearchLoading: true,
        staffToStaffHolidayCalendarPeriodSearchError: null,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_SUCCESS:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodSearch: action.payload,
        staffToStaffHolidayCalendarPeriodSearchLoading: false,
      };
    case STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_FAIL:
      return {
        ...state,
        staffToStaffHolidayCalendarPeriodSearch: [],
        staffToStaffHolidayCalendarPeriodSearchLoading: false,
        staffToStaffHolidayCalendarPeriodSearchError: action.payload,
      };

    case STAFF_LEAVE_RESTRICTION_PERIOD_LIST:
      return {
        ...state,
        staffLeaveRestrictionPeriodListLoading: true,
        staffLeaveRestrictionPeriodListError: null,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_LIST_SUCCESS:
      return {
        ...state,
        staffLeaveRestrictionPeriodList: action.payload,
        staffLeaveRestrictionPeriodListLoading: false,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_LIST_FAIL:
      return {
        ...state,
        staffLeaveRestrictionPeriodList: [],
        staffLeaveRestrictionPeriodListLoading: false,
        staffLeaveRestrictionPeriodListError: action.payload,
      };

    case STAFF_LEAVE_RESTRICTION_PERIOD_DATA:
      return {
        ...state,
        staffLeaveRestrictionPeriodDataLoading: true,
        staffLeaveRestrictionPeriodDataError: null,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_DATA_SUCCESS:
      return {
        ...state,
        staffLeaveRestrictionPeriodData: action.payload,
        staffLeaveRestrictionPeriodDataLoading: false,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_DATA_FAIL:
      return {
        ...state,
        staffLeaveRestrictionPeriodData: [],
        staffLeaveRestrictionPeriodDataLoading: false,
        staffLeaveRestrictionPeriodDataError: action.payload,
      };

    case STAFF_LEAVE_RESTRICTION_PERIOD_CREATE:
      return {
        ...state,
        staffLeaveRestrictionPeriodCreateLoading: true,
        staffLeaveRestrictionPeriodCreateError: null,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_SUCCESS:
      return {
        ...state,
        staffLeaveRestrictionPeriodCreate: action.payload,
        staffLeaveRestrictionPeriodCreateLoading: false,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_FAIL:
      return {
        ...state,
        staffLeaveRestrictionPeriodCreate: [],
        staffLeaveRestrictionPeriodCreateLoading: false,
        staffLeaveRestrictionPeriodCreateError: action.payload,
      };

    case STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE:
      return {
        ...state,
        staffLeaveRestrictionPeriodUpdateLoading: true,
        staffLeaveRestrictionPeriodUpdateError: null,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_SUCCESS:
      return {
        ...state,
        staffLeaveRestrictionPeriodUpdate: action.payload,
        staffLeaveRestrictionPeriodUpdateLoading: false,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_FAIL:
      return {
        ...state,
        staffLeaveRestrictionPeriodUpdate: [],
        staffLeaveRestrictionPeriodUpdateLoading: false,
        staffLeaveRestrictionPeriodUpdateError: action.payload,
      };

    case STAFF_LEAVE_RESTRICTION_PERIOD_DELETE:
      return {
        ...state,
        staffLeaveRestrictionPeriodDeleteLoading: true,
        staffLeaveRestrictionPeriodDeleteError: null,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_SUCCESS:
      return {
        ...state,
        staffLeaveRestrictionPeriodDelete: action.payload,
        staffLeaveRestrictionPeriodDeleteLoading: false,
      };
    case STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_FAIL:
      return {
        ...state,
        staffLeaveRestrictionPeriodDelete: [],
        staffLeaveRestrictionPeriodDeleteLoading: false,
        staffLeaveRestrictionPeriodDeleteError: action.payload,
      };

    case SEED_APPROVED_STAFF_LEAVE:
      return {
        ...state,
        seedApprovedStaffLeaveLoading: true,
        seedApprovedStaffLeaveError: null,
      };
    case SEED_APPROVED_STAFF_LEAVE_SUCCESS:
      return {
        ...state,
        seedApprovedStaffLeave: action.payload,
        seedApprovedStaffLeaveLoading: false,
      };
    case SEED_APPROVED_STAFF_LEAVE_FAIL:
      return {
        ...state,
        seedApprovedStaffLeave: [],
        seedApprovedStaffLeaveLoading: false,
        seedApprovedStaffLeaveError: action.payload,
      };

    default:
      return state;
  }
};
export default StaffLeave;
